
export default {
  props: ["item"],
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    async getGroup() {
      if (this.item.group) {
        let temp = await this.$axios.$get(
          `${process.env.axiosUrl}/items/store/${this.$store.getters.store._id}?store_id=${this.$store.getters.store._id}&group=${this.item.group}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        );
        if (temp.items && temp.items.docs) {
          this.items = temp.items.docs.filter(
            (i) => i.barcode != this.item.barcode
          );
        }
      }
    },
  },
};
